import { render, staticRenderFns } from "./MessageModalCreateOrUpdate.vue?vue&type=template&id=736dfdd2&scoped=true&"
import script from "./MessageModalCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./MessageModalCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736dfdd2",
  null
  
)

export default component.exports